// extracted by mini-css-extract-plugin
export default {"noProvider":"data-row-entry_noProvider__5Xg3v"};